<template>
	<div>
		<div v-if="diagnose" class="panel m-5">
			<PanelHeader panel-header="Diagnose" />
			<div class="container pt-3 pb-3">
				<div class="columns">
					<div class="column">
						<b-field label="Bezeichner">
							<p class="content">
								{{ diagnoseName }}
							</p>
						</b-field>
					</div>
				</div>
			</div>
		</div>
		<div>
			<section class="m-5">
				<b-button class="is-danger" tag="router-link" to="/diagnose">
					Zurück
				</b-button>
			</section>
		</div>
	</div>
</template>
  
<script>
/**
 * This file is for viewing a focused diagnose.
 */

import PanelHeader from "@/components/helperComponents/PanelHeader";

export default {
	name: "ViewDiagnose",
	components: {
		PanelHeader,
	},
	data() {
		return {
			diagnose: undefined,
			diagnoseName: "",
		};
	},
	computed: {},
	mounted() {
		this.scrollToElement()
		if (this.$route.params.data) {
			this.diagnose = this.$route.params.data
			this.diagnoseName = this.diagnose.attributes.name
		}
	},
	methods: {
		scrollToElement() {
			const el = this.$parent.$parent.$refs.scrollToMe;
			if (el) {
				el.scrollIntoView({ behavior: 'smooth' });
			}
		}
	}
}
</script>
  
<style lang="scss" scoped>
.image_column {
	max-width: 200px;
}
</style>
  